(function(window, document) {
  "use strict";
  if (window.AuxitoVehicleUtils) {
    return;
  }
  window.Auxito=window.Auxito || {};
  window.Auxito.Vehicle = window.Auxito.Vehicle || {};
  var fitmentEngine = window.AuxitoFitmentEngine || null;
  if (!fitmentEngine) {
    console.warn("AuxitoFitmentEngine is required for vehicle utils.");
    return;
  }
  var STORAGE_KEY = "auxito_vehicles";
  var LEGACY_VEHICLE_MODE_KEY = "auxito_vehicle_browse_mode";
  var MAX_VEHICLES = 5;
  var LEGACY_JSON_VERSION = fitmentEngine.LEGACY_JSON_VERSION || "260421";
  var DEFAULT_SELECTOR_LIBRARY_VERSION = String(window.__AUXITO_VEHICLE_LIBRARY_VERSION__ || LEGACY_JSON_VERSION).trim() || LEGACY_JSON_VERSION;
  var VEHICLE_SELECTOR_ARTIFACTS_CONFIG_SCRIPT_ID = "vehicle-selector-artifacts-config";
  var VEHICLE_SELECTOR_INDEX_SESSION_KEY_PREFIX = "auxito:vehicle-selector-index:";
  var VEHICLE_SELECTOR_YEAR_SESSION_KEY_PREFIX = "auxito:vehicle-selector-year:";
  var readSessionCache = fitmentEngine.readSessionJson;
  var writeSessionCache = fitmentEngine.writeSessionJson;
  var toSessionCacheKey = fitmentEngine.toSessionCacheKey;
  var parseJsonScriptById = fitmentEngine.parseJsonScriptById;
  var normalizeBaseUrl = fitmentEngine.normalizeArtifactsBaseUrl;
  var resolveUrlAgainstBase = fitmentEngine.resolveUrlAgainstBase;
  var fetchVehicleJson = fitmentEngine.fetchPublicJson;
  var fetchVehicleLibraryManifest = typeof fitmentEngine.fetchVehicleLibraryManifest === "function" ? fitmentEngine.fetchVehicleLibraryManifest : function() { return Promise.resolve(null); };
  var getManifestArtifactUrl = typeof fitmentEngine.getManifestArtifactUrl === "function" ? fitmentEngine.getManifestArtifactUrl : function() { return ""; };
  var getCaseInsensitivePropertyName = fitmentEngine.getCaseInsensitivePropertyName;
  var getCaseInsensitivePropertyValue = fitmentEngine.getCaseInsensitivePropertyValue;
  var vehicleApiPromise = null;
  var selectorArtifactsConfig = null;
  var selectorIndexData = null;
  var selectorIndexPromise = null;
  var selectorYearDataCache = {};
  var selectorYearDataPromiseCache = {};
  var fitParamResolvePromiseCache = {};
  function normalizeVehicle(vehicle) {
    if (!vehicle) {
      return null;
    }
    var normalized = {
      year: String(vehicle.year || "").trim(),
      make: String(vehicle.make || "").trim(),
      model: String(vehicle.model || "").trim()
    };
    if (!normalized.year || !normalized.make || !normalized.model) {
      return null;
    }
    if (vehicle.id != null) {
      normalized.id = vehicle.id;
    }
    if (vehicle.trim != null && String(vehicle.trim || "").trim()) {
      normalized.trim = String(vehicle.trim || "").trim();
    }
    normalized.display = String(vehicle.display || "").trim() || [ normalized.year, normalized.make, normalized.model, normalized.trim ].filter(Boolean).join(" ").trim();
    return normalized;
  }
  function buildVehicleDisplay(vehicle, fallback) {
    var normalized = normalizeVehicle(vehicle);
    if (normalized && normalized.display) {
      return normalized.display;
    }
    return window.AuxitoUtils.buildVehicleDisplay(normalized || vehicle, fallback);
  }
  function createVehicleIdentity(vehicle) {
    var normalized = normalizeVehicle(vehicle);
    if (!normalized) {
      return "";
    }
    return [ normalized.year, normalized.make, normalized.model ].join("||").toLowerCase();
  }
  function readStoragePayload() {
    return window.AuxitoUtils.readJson(window.localStorage, STORAGE_KEY) || {};
  }
  function normalizePreviousVehicles(items, current) {
    var currentIdentity = createVehicleIdentity(current);
    var normalizedItems = Array.isArray(items) ? items.map(normalizeVehicle).filter(Boolean) : [];
    var seen = {};
    var limit = currentIdentity ? Math.max(MAX_VEHICLES - 1, 0) : MAX_VEHICLES;
    return normalizedItems.filter(function(item) {
      var identity = createVehicleIdentity(item);
      if (!identity || identity === currentIdentity || seen[identity]) {
        return false;
      }
      seen[identity] = true;
      return true;
    }).slice(0, limit);
  }
  try {
    window.localStorage.removeItem(LEGACY_VEHICLE_MODE_KEY);
  } catch (error) {}
  var sharedVehicleStorage = window.Auxito.Vehicle.Storage && typeof window.Auxito.Vehicle.Storage.load === "function" ? window.Auxito.Vehicle.Storage : {
    STORAGE_KEY: STORAGE_KEY,
    MAX_VEHICLES: MAX_VEHICLES,
    _writeTimeout: null,
    load: function() {
      var data = readStoragePayload();
      var current = normalizeVehicle(data.current || null);
      return {
        current: current,
        previous: normalizePreviousVehicles(data.previous, current)
      };
    },
    save: function(current, previous) {
      var normalizedCurrent = normalizeVehicle(current);
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
          current: normalizedCurrent,
          previous: normalizePreviousVehicles(previous, normalizedCurrent),
          timestamp: Date.now()
        }));
        return true;
      } catch (error) {
        console.warn("Failed to save vehicle data:", error);
        return false;
      }
    },
    saveDebounced: function(current, previous, delay) {
      var self = this;
      window.clearTimeout(this._writeTimeout);
      this._writeTimeout = window.setTimeout(function() {
        self.save(current, previous);
      }, Number(delay) > 0 ? Number(delay) : 100);
    },
    clear: function() {
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        console.warn("Failed to clear vehicle data:", error);
      }
    },
    addVehicle: function(vehicle) {
      var hasTrimInput = !!(vehicle && Object.prototype.hasOwnProperty.call(vehicle, "trim"));
      var nextVehicle = normalizeVehicle(vehicle);
      var loaded;
      var current;
      var previous;
      var nextIdentity;
      if (!nextVehicle) {
        return this.load();
      }
      if (nextVehicle.id == null) {
        nextVehicle.id = Date.now() + Math.random();
      }
      loaded = this.load();
      current = loaded.current;
      previous = loaded.previous;
      nextIdentity = createVehicleIdentity(nextVehicle);
      if (current) {
        if (createVehicleIdentity(current) === nextIdentity) {
          var mergedCurrent = Object.assign({}, current, nextVehicle, {
            id: current.id
          });
          if (hasTrimInput && !String(vehicle.trim || "").trim()) {
            delete mergedCurrent.trim;
            delete mergedCurrent.display;
          } else if (!hasTrimInput && current.trim && !nextVehicle.trim) {
            mergedCurrent.trim = current.trim;
            delete mergedCurrent.display;
          }
          mergedCurrent.display = String(nextVehicle.display && (nextVehicle.trim || !mergedCurrent.trim) ? nextVehicle.display : buildVehicleDisplay(mergedCurrent, current.display)).trim();
          if (String(mergedCurrent.display || "") !== String(current.display || "") || String(mergedCurrent.trim || "") !== String(current.trim || "")) {
            this.save(mergedCurrent, previous);
            return {
              current: normalizeVehicle(mergedCurrent),
              previous: normalizePreviousVehicles(previous, mergedCurrent)
            };
          }
          return loaded;
        }
        previous.unshift(current);
      }
      previous = previous.filter(function(item) {
        return createVehicleIdentity(item) !== nextIdentity;
      });
      this.save(nextVehicle, previous);
      return {
        current: nextVehicle,
        previous: normalizePreviousVehicles(previous, nextVehicle)
      };
    },
    removeVehicle: function(vehicleId) {
      var loaded = this.load();
      var current = loaded.current;
      var previous = loaded.previous.filter(function(item) {
        return item.id !== vehicleId;
      });
      if (current && current.id === vehicleId) {
        current = previous.length ? previous.shift() : null;
      }
      this.save(current, previous);
      return {
        current: current,
        previous: normalizePreviousVehicles(previous, current)
      };
    },
    updateVehicle: function(vehicleId, updatedVehicle) {
      var loaded = this.load();
      var current = loaded.current;
      var previous = loaded.previous;
      var mergedVehicle = normalizeVehicle(updatedVehicle);
      if (current && current.id === vehicleId) {
        current = Object.assign({}, current, mergedVehicle || {}, {
          id: vehicleId
        });
        current.display = buildVehicleDisplay(current, current.display);
      }
      previous = previous.map(function(item) {
        if (item.id !== vehicleId) {
          return item;
        }
        var nextItem = Object.assign({}, item, mergedVehicle || {}, {
          id: vehicleId
        });
        nextItem.display = buildVehicleDisplay(nextItem, nextItem.display);
        return nextItem;
      });
      this.save(current, previous);
      return {
        current: current,
        previous: normalizePreviousVehicles(previous, current)
      };
    },
    switchToVehicle: function(targetVehicle) {
      var loaded = this.load();
      var current = loaded.current;
      var previous = loaded.previous;
      var target = normalizeVehicle(targetVehicle);
      var targetIndex;
      var nextCurrent;
      if (!target) {
        return loaded;
      }
      targetIndex = previous.findIndex(function(item) {
        return item.id === target.id;
      });
      if (targetIndex === -1) {
        return this.addVehicle(target);
      }
      nextCurrent = previous.splice(targetIndex, 1)[0];
      if (current) {
        previous.unshift(current);
      }
      this.save(nextCurrent, previous);
      return {
        current: nextCurrent,
        previous: normalizePreviousVehicles(previous, nextCurrent)
      };
    }
  };
  window.Auxito.Vehicle.Storage = sharedVehicleStorage;
  function getVehicleStorage() {
    return window.Auxito.Vehicle.Storage || sharedVehicleStorage;
  }
  function getCurrentVehicle() {
    var storage = getVehicleStorage();
    var loaded = storage && typeof storage.load === "function" ? storage.load() : null;
    return normalizeVehicle(loaded && loaded.current ? loaded.current : null);
  }
  function decodeFitParamValue(value) {
    var text = String(value || "").trim();
    try {
      text = decodeURIComponent(text.replace(/\+/g, " "));
    } catch (error) {}
    return text.trim();
  }
  function normalizeFitComparable(value) {
    return decodeFitParamValue(value).toLowerCase().replace(/&/g, " and ").replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
  }
  function tokenizeFitValue(value) {
    var normalized = normalizeFitComparable(value);
    return normalized ? normalized.split(" ").filter(Boolean) : [];
  }
  // 同时支持普通分词和紧凑写法，例如 f150 可以匹配 F-150。
  function matchCandidateTokens(candidate, inputTokens, offset) {
    var candidateTokens = tokenizeFitValue(candidate);
    var compactCandidate;
    var compactInput;
    var size;
    if (!candidateTokens.length || !Array.isArray(inputTokens) || offset >= inputTokens.length) {
      return 0;
    }
    if (candidateTokens.every(function(token, index) {
      return inputTokens[offset + index] === token;
    })) {
      return candidateTokens.length;
    }
    compactCandidate = candidateTokens.join("");
    for (size = 1; size <= Math.min(candidateTokens.length, inputTokens.length - offset); size += 1) {
      compactInput = inputTokens.slice(offset, offset + size).join("");
      if (compactInput === compactCandidate) {
        return size;
      }
    }
    return 0;
  }
  function findLongestFitPrefix(candidates, inputTokens, offset) {
    var matches = (Array.isArray(candidates) ? candidates : []).map(function(candidate) {
      var consumed = matchCandidateTokens(candidate, inputTokens, offset);
      return consumed ? {
        value: String(candidate || "").trim(),
        consumed: consumed,
        tokenCount: tokenizeFitValue(candidate).length
      } : null;
    }).filter(Boolean);
    matches.sort(function(left, right) {
      return right.consumed - left.consumed || right.tokenCount - left.tokenCount || right.value.length - left.value.length;
    });
    return matches[0] || null;
  }
  function formatFitDescriptorToken(token) {
    var text = String(token || "").trim();
    if (!text) {
      return "";
    }
    // 汽车 trim 常见写法是大写，例如 GT、LT、LX、4X4。
    if (text.length <= 3 || /\d/.test(text)) {
      return text.toUpperCase();
    }
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }
  function formatFitDescriptor(tokens) {
    return (Array.isArray(tokens) ? tokens : []).map(formatFitDescriptorToken).filter(Boolean).join(" ").trim();
  }
  function slugifyFitSegment(value) {
    return tokenizeFitValue(value).join("_");
  }
  function buildFitParamFromVehicle(vehicle) {
    var normalized = normalizeVehicle(vehicle);
    var segments;
    if (!normalized) {
      return "";
    }
    segments = [ normalized.year, normalized.make, normalized.model, normalized.trim ].map(slugifyFitSegment).filter(Boolean);
    return segments.length >= 3 ? "veh_" + segments.join("_") : "";
  }
  async function resolveVehicleFromFitParamUncached(fitValue) {
    var rawValue = decodeFitParamValue(fitValue);
    var tokens = tokenizeFitValue(rawValue);
    var year;
    var indexData;
    var matchedYear;
    var makes;
    var makeMatch;
    var yearData;
    var models;
    var modelMatch;
    var remainderTokens;
    var trim;
    var vehicle;
    if (!rawValue || tokens[0] !== "veh" || !/^\d{4}$/.test(tokens[1] || "")) {
      return {
        status: "invalid",
        reason: "invalid_format"
      };
    }
    year = tokens[1];
    try {
      indexData = await fetchSelectorIndexData();
      matchedYear = (indexData.years || []).find(function(item) {
        return String(item || "").trim() === year;
      });
      if (!matchedYear) {
        return {
          status: "not_found",
          reason: "year_not_found",
          partial: {
            year: year
          }
        };
      }
      makes = getAvailableMakes(indexData, matchedYear);
      makeMatch = findLongestFitPrefix(makes, tokens, 2);
      if (!makeMatch) {
        return {
          status: "not_found",
          reason: "make_not_found",
          partial: {
            year: matchedYear
          }
        };
      }
      yearData = await fetchSelectorYearData(matchedYear);
      models = getAvailableModels(yearData, makeMatch.value);
      modelMatch = findLongestFitPrefix(models, tokens, 2 + makeMatch.consumed);
      if (!modelMatch) {
        return {
          status: "not_found",
          reason: "model_not_found",
          partial: {
            year: matchedYear,
            make: makeMatch.value
          }
        };
      }
      remainderTokens = tokens.slice(2 + makeMatch.consumed + modelMatch.consumed);
      trim = formatFitDescriptor(remainderTokens);
      vehicle = {
        year: matchedYear,
        make: makeMatch.value,
        model: modelMatch.value
      };
      if (trim) {
        vehicle.trim = trim;
      }
      vehicle.display = [ vehicle.year, vehicle.make, vehicle.model, vehicle.trim ].filter(Boolean).join(" ").trim();
      return {
        status: "matched",
        vehicle: normalizeVehicle(vehicle),
        fit: buildFitParamFromVehicle(vehicle)
      };
    } catch (error) {
      return {
        status: "unresolved",
        reason: String(error && error.message || "vehicle_library_unavailable"),
        partial: year ? {
          year: year
        } : null
      };
    }
  }
  function resolveVehicleFromFitParam(fitValue) {
    var cacheKey = normalizeFitComparable(fitValue);
    if (!cacheKey) {
      return Promise.resolve({
        status: "invalid",
        reason: "invalid_format"
      });
    }
    if (!fitParamResolvePromiseCache[cacheKey]) {
      // 先按车型库匹配 year/make/model，剩余 token 再作为 trim。
      fitParamResolvePromiseCache[cacheKey] = resolveVehicleFromFitParamUncached(fitValue);
    }
    return fitParamResolvePromiseCache[cacheKey];
  }
  function readVehicleSelectorArtifactsConfig() {
    var parsed = parseJsonScriptById(VEHICLE_SELECTOR_ARTIFACTS_CONFIG_SCRIPT_ID, "vehicle selector artifacts config") || {};
    var selectorYearBaseUrl = normalizeBaseUrl(parsed.selector_year_base_url || parsed.selectorYearBaseUrl || parsed.year_base_url || parsed.yearBaseUrl || "");
    var selectorVersion = String(parsed.selector_version || parsed.selectorVersion || parsed.version || DEFAULT_SELECTOR_LIBRARY_VERSION).trim() || DEFAULT_SELECTOR_LIBRARY_VERSION;
    return {
      selectorIndexUrl: String(parsed.selector_index_url || parsed.selectorIndexUrl || parsed.index_url || parsed.indexUrl || "").trim(),
      selectorYearBaseUrl: selectorYearBaseUrl,
      selectorVersion: selectorVersion,
      sourceManifestIndexUrl: String(parsed.source_manifest_index_url || parsed.sourceManifestIndexUrl || "").trim(),
      fitmentShardBaseUrl: selectorYearBaseUrl,
      fitmentShardVersion: selectorVersion
    };
  }
  function getVehicleSelectorArtifactsConfig() {
    if (!selectorArtifactsConfig) {
      selectorArtifactsConfig = readVehicleSelectorArtifactsConfig();
    }
    return selectorArtifactsConfig;
  }
  function normalizeSelectorYearToken(year) {
    var normalizedYear = String(year || "").trim().toLowerCase().replace(/\s+/g, "_").replace(/\+/g, "_");
    if (normalizedYear === "/" || normalizedYear === "universal") {
      return "unlimited";
    }
    return normalizedYear;
  }
  function buildSelectorYearArtifactUrl(year) {
    var config = getVehicleSelectorArtifactsConfig();
    if (!config.selectorYearBaseUrl) {
      return "";
    }
    return resolveUrlAgainstBase("vehicle-selector-year-" + config.selectorVersion + "-" + normalizeSelectorYearToken(year) + ".json", config.selectorYearBaseUrl);
  }
  function buildSelectorYearLogicalKey(year) {
    return "vehicle-selector-year:" + normalizeSelectorYearToken(year);
  }
  function getSelectorManifest() {
    return fetchVehicleLibraryManifest(getVehicleSelectorArtifactsConfig());
  }
  function normalizeSelectorIndexPayload(payload) {
    var rawYears;
    var rawMakesByYear;
    var normalizedMakesByYear = {};
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
      throw new Error("Invalid vehicle selector index payload");
    }
    rawYears = Array.isArray(payload.years) ? payload.years : [];
    rawMakesByYear = payload.makes_by_year || payload.makesByYear || {};
    rawYears.forEach(function(year) {
      var yearKey = String(year || "").trim();
      var makes = getCaseInsensitivePropertyValue(rawMakesByYear, yearKey);
      normalizedMakesByYear[yearKey] = Array.isArray(makes) ? makes.map(function(make) {
        return String(make || "").trim();
      }).filter(Boolean) : [];
    });
    return {
      version: Number(payload.version || 1),
      selectorVersion: String(payload.selector_version || payload.selectorVersion || getVehicleSelectorArtifactsConfig().selectorVersion || DEFAULT_SELECTOR_LIBRARY_VERSION).trim(),
      years: rawYears.map(function(year) {
        return String(year || "").trim();
      }).filter(Boolean),
      makesByYear: normalizedMakesByYear
    };
  }
  function normalizeSelectorYearPayload(payload, expectedYear) {
    var rawMakes;
    var normalizedMakes = {};
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
      throw new Error("Invalid vehicle selector year payload");
    }
    rawMakes = payload.makes || {};
    Object.keys(rawMakes).forEach(function(make) {
      normalizedMakes[make] = Array.isArray(rawMakes[make]) ? rawMakes[make].map(function(model) {
        return String(model || "").trim();
      }).filter(Boolean) : [];
    });
    if (expectedYear && payload.year && String(payload.year).trim() !== String(expectedYear).trim()) {
      throw new Error("Unexpected vehicle selector year payload");
    }
    return {
      version: Number(payload.version || 1),
      selectorVersion: String(payload.selector_version || payload.selectorVersion || getVehicleSelectorArtifactsConfig().selectorVersion || DEFAULT_SELECTOR_LIBRARY_VERSION).trim(),
      year: String(payload.year || expectedYear || "").trim(),
      makes: normalizedMakes
    };
  }
  function fetchSelectorIndexData() {
    var config = getVehicleSelectorArtifactsConfig();
    var cacheKey = toSessionCacheKey(VEHICLE_SELECTOR_INDEX_SESSION_KEY_PREFIX, [ config.selectorVersion, config.selectorIndexUrl, config.sourceManifestIndexUrl ].join("::"));
    var cachedIndex;
    if (!config.selectorIndexUrl && !config.sourceManifestIndexUrl) {
      return Promise.reject(new Error("Missing vehicle selector index URL"));
    }
    if (selectorIndexData) {
      return Promise.resolve(selectorIndexData);
    }
    cachedIndex = readSessionCache(cacheKey);
    if (cachedIndex && cachedIndex.years && cachedIndex.makesByYear) {
      selectorIndexData = cachedIndex;
      return Promise.resolve(selectorIndexData);
    }
    if (!selectorIndexPromise) {
      selectorIndexPromise = getSelectorManifest().then(function(manifest) {
        var artifactUrl = getManifestArtifactUrl(manifest, "vehicle-selector-index") || config.selectorIndexUrl;
        if (!artifactUrl) {
          throw new Error("Missing vehicle selector index URL");
        }
        return fetchVehicleJson(artifactUrl);
      }).then(function(payload) {
        selectorIndexData = normalizeSelectorIndexPayload(payload);
        writeSessionCache(cacheKey, selectorIndexData);
        return selectorIndexData;
      }).catch(function(error) {
        selectorIndexPromise = null;
        throw error;
      }).finally(function() {
        selectorIndexPromise = null;
      });
    }
    return selectorIndexPromise;
  }
  function fetchSelectorYearData(year) {
    var yearKey = String(year || "").trim();
    var config = getVehicleSelectorArtifactsConfig();
    var yearCacheKey = [ config.selectorVersion, config.sourceManifestIndexUrl, yearKey ].join("::");
    var cacheKey = toSessionCacheKey(VEHICLE_SELECTOR_YEAR_SESSION_KEY_PREFIX, yearCacheKey);
    var cachedYearData;
    if (!yearKey) {
      return Promise.reject(new Error("Missing year"));
    }
    if (!config.selectorYearBaseUrl && !config.sourceManifestIndexUrl) {
      return Promise.reject(new Error("Missing vehicle selector year artifact URL"));
    }
    if (selectorYearDataCache[yearCacheKey]) {
      return Promise.resolve(selectorYearDataCache[yearCacheKey]);
    }
    cachedYearData = readSessionCache(cacheKey);
    if (cachedYearData && cachedYearData.makes) {
      selectorYearDataCache[yearCacheKey] = cachedYearData;
      return Promise.resolve(selectorYearDataCache[yearCacheKey]);
    }
    if (!selectorYearDataPromiseCache[yearCacheKey]) {
      selectorYearDataPromiseCache[yearCacheKey] = getSelectorManifest().then(function(manifest) {
        var artifactUrl = getManifestArtifactUrl(manifest, buildSelectorYearLogicalKey(yearKey)) || buildSelectorYearArtifactUrl(yearKey);
        if (!artifactUrl) {
          throw new Error("Missing vehicle selector year artifact URL");
        }
        return fetchVehicleJson(artifactUrl);
      }).then(function(payload) {
        selectorYearDataCache[yearCacheKey] = normalizeSelectorYearPayload(payload, yearKey);
        writeSessionCache(cacheKey, selectorYearDataCache[yearCacheKey]);
        return selectorYearDataCache[yearCacheKey];
      }).catch(function(error) {
        delete selectorYearDataPromiseCache[yearCacheKey];
        throw error;
      }).finally(function() {
        delete selectorYearDataPromiseCache[yearCacheKey];
      });
    }
    return selectorYearDataPromiseCache[yearCacheKey];
  }
  function getVehicleData() {
    return fetchSelectorIndexData();
  }
  function getYearVehicleData(year) {
    var yearKey = String(year || "").trim();
    if (!yearKey) {
      return Promise.reject(new Error("Missing year"));
    }
    return fetchSelectorYearData(yearKey);
  }
  function getAvailableYears(data) {
    if (data && Array.isArray(data.years)) {
      return data.years.slice().sort(function(a, b) {
        if (a === "Universal") return 1;
        if (b === "Universal") return -1;
        return Number(b) - Number(a);
      });
    }
    var yearSet = new Set;
    Object.values(data || {}).forEach(function(categoryData) {
      Object.keys(categoryData || {}).forEach(function(year) {
        yearSet.add(year);
      });
    });
    return Array.from(yearSet).sort(function(a, b) {
      if (a === "Universal") return 1;
      if (b === "Universal") return -1;
      return Number(b) - Number(a);
    });
  }
  function getAvailableMakes(data, year) {
    if (data && data.makesByYear) {
      var indexedMakes = getCaseInsensitivePropertyValue(data.makesByYear, year);
      return Array.isArray(indexedMakes) ? indexedMakes.slice().sort(function(a, b) {
        return a.localeCompare(b);
      }) : [];
    }
    var makesMap = new Map;
    Object.values(data || {}).forEach(function(categoryData) {
      var yearData = getCaseInsensitivePropertyValue(categoryData, year);
      Object.keys(yearData || {}).forEach(function(make) {
        makesMap.set(make.toLowerCase(), make);
      });
    });
    return Array.from(makesMap.values()).sort(function(a, b) {
      return a.localeCompare(b);
    });
  }
  function getAvailableModels(yearData, make) {
    if (yearData && yearData.makes) {
      var indexedModels = getCaseInsensitivePropertyValue(yearData.makes, make);
      return Array.isArray(indexedModels) ? indexedModels.slice().sort(function(a, b) {
        return a.localeCompare(b);
      }) : [];
    }
    var modelsMap = new Map;
    Object.values(yearData || {}).forEach(function(categoryData) {
      var makeData = getCaseInsensitivePropertyValue(categoryData, make);
      Object.keys(makeData || {}).forEach(function(model) {
        modelsMap.set(model.toLowerCase(), model);
      });
    });
    return Array.from(modelsMap.values()).sort(function(a, b) {
      return a.localeCompare(b);
    });
  }
  var sharedVehicleDataApi = window.Auxito.Vehicle.DataApi && typeof window.Auxito.Vehicle.DataApi.getVehicleData === "function" ? window.Auxito.Vehicle.DataApi : {
    getVehicleData: getVehicleData,
    getYearVehicleData: getYearVehicleData,
    getAvailableYears: getAvailableYears,
    getAvailableMakes: getAvailableMakes,
    getAvailableModels: getAvailableModels
  };
  window.Auxito.Vehicle.DataApi = sharedVehicleDataApi;
  function waitForVehicleDataApi(timeoutMs) {
    if (window.Auxito.Vehicle.DataApi) {
      return Promise.resolve(window.Auxito.Vehicle.DataApi);
    }
    if (!vehicleApiPromise) {
      vehicleApiPromise = new Promise(function(resolve, reject) {
        var startedAt = Date.now();
        var maxWaitMs = Number(timeoutMs) > 0 ? Number(timeoutMs) : 5e3;
        (function checkApi() {
          if (window.Auxito.Vehicle.DataApi) {
            resolve(window.Auxito.Vehicle.DataApi);
            return;
          }
          if (Date.now() - startedAt > maxWaitMs) {
            reject(new Error("VehicleDataApi is not available"));
            return;
          }
          window.setTimeout(checkApi, 50);
        })();
      }).finally(function() {
        vehicleApiPromise = null;
      });
    }
    return vehicleApiPromise;
  }
  function syncVehicleStorageUi(options) {
    var selectorApi = window.Auxito && window.Auxito.Vehicle && window.Auxito.Vehicle.Selector ? window.Auxito.Vehicle.Selector : null;
    if (selectorApi && typeof selectorApi.syncVehicleStorageState === "function") {
      return selectorApi.syncVehicleStorageState(options || {});
    }
    if (typeof window.loadSavedVehicles=== "function") {
      window.loadSavedVehicles();
    }
    if (typeof window.updateVehicleSelectionText=== "function") {
      window.updateVehicleSelectionText();
    }
    if (typeof window.renderPreviousVehicles=== "function") {
      window.renderPreviousVehicles();
    }
    if (typeof window.updatePreviousSection=== "function") {
      window.updatePreviousSection();
    }
    if (options && options.showSelectedState && typeof window.showSelectedState=== "function" && document.getElementById("vehicleSelected") && document.getElementById("vehicleForm")) {
      window.showSelectedState();
    }
    return null;
  }
  window.AuxitoVehicleUtils={
    STORAGE_KEY: STORAGE_KEY,
    MAX_VEHICLES: MAX_VEHICLES,
    LEGACY_JSON_VERSION: LEGACY_JSON_VERSION,
    getVehicleSelectorArtifactsConfig: getVehicleSelectorArtifactsConfig,
    normalizeVehicle: normalizeVehicle,
    buildVehicleDisplay: buildVehicleDisplay,
    getVehicleStorage: getVehicleStorage,
    getCurrentVehicle: getCurrentVehicle,
    getCaseInsensitivePropertyName: getCaseInsensitivePropertyName,
    getCaseInsensitivePropertyValue: getCaseInsensitivePropertyValue,
    getVehicleDataApi: function() {
      return window.Auxito.Vehicle.DataApi || sharedVehicleDataApi;
    },
    getVehicleData: getVehicleData,
    getYearVehicleData: getYearVehicleData,
    getAvailableYears: getAvailableYears,
    getAvailableMakes: getAvailableMakes,
    getAvailableModels: getAvailableModels,
    buildFitParamFromVehicle: buildFitParamFromVehicle,
    resolveVehicleFromFitParam: resolveVehicleFromFitParam,
    waitForVehicleDataApi: waitForVehicleDataApi,
    syncVehicleStorageUi: syncVehicleStorageUi
  };
})(window, document);
